<template lang="pug">
  div.cotizacion-section
    div.row-title.d-flex.pb-3
      b-icon-file-text.mr-2.title
      h3.title Cotización
    //- Comentarios
    .comentarios-grid
      .data-item.wide
        h4.data-label Comentario Vendedor
        h4.data-info {{ ovData.comentario_vendedor }}
      .data-item.wide
        h4.data-label Comentario Cierre
        h4.data-info {{ ovData.comentario_cierre }}
</template>

<script>
export default {
  name: 'OVDetailCotizacionYBoletas',
  props: {
    ov: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ovData() {
      return {
        comentario_cierre: this.ov.comentario_cierre || '-',
        comentario_vendedor: this.ov.comentario_vendedor || '-',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.title {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
}

.row-title {
  align-items: center;
}

.data-label {
  font-size: 15px;
  font-weight: 700;
  text-align: left;
  color: #525252;
  margin: 0;
}

.data-info {
  font-size: 15px;
  font-weight: 400;
  color: #525252;
  text-align: left;
}

.cotizacion-section {
  display: flex;
  flex-direction: column;
  margin-top: 30px;
}

.comentarios-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.5rem 0;
}

.data-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
</style>
